import { Stack } from '@mantine/core';
import {
  resetMonthlyAveragesFilters,
  selectAllMonthlyAveragesMeasures,
  toggleMonthlyAveragesMeasureSelection,
} from '../../../../store/process-analysis-store/process-analysis-store.actions';
import {
  useAllAvailableMeasureNames,
  useGroupedMeasures,
  useSelectedMonthlyAveragesMeasures,
} from '../../../../store/process-analysis-store/process-analysis-store.hooks';
import { MeasureGroup } from '../../components/measure-filters/measure-group';
import { ResetFiltersButton } from '../../../../components/filters/reset-filters-button';
import { SelectAllButton } from '../../../../components/filters/select-all-button';

export const MonthlyAverages = () => {
  const groupedMeasures = useGroupedMeasures();
  const selectedMonthlyAveragesMeasures = useSelectedMonthlyAveragesMeasures();
  const allAvailableMeasureNames = useAllAvailableMeasureNames();

  return (
    <Stack pb={40}>
      {Object.entries(groupedMeasures).map(([groupName, measures], index) => (
        <MeasureGroup
          key={groupName}
          groupName={groupName}
          measures={measures}
          isFirst={index === 0}
          showTrends={false}
          selectedMeasures={selectedMonthlyAveragesMeasures}
          onMeasureToggle={toggleMonthlyAveragesMeasureSelection}
        />
      ))}
      <SelectAllButton
        onClick={() => {
          selectAllMonthlyAveragesMeasures(allAvailableMeasureNames);
        }}
      />
      <ResetFiltersButton
        onClick={() => {
          resetMonthlyAveragesFilters();
        }}
      />
    </Stack>
  );
};
